import React, { PropTypes } from 'react';
import cx from 'classnames';
import s from './style';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
// Часть стилей находтся в assets/style.css в самом низу (они не работают с sass cssModules)
function InputForm({ className, label, options, input: { onBlur, value, ...other }, required, placeholder, meta: { touched, error } }) {
  const classes = cx(s.root, className, touched && error && s.error);
  return (
    <div className={classes}>
      <div className={s.label}>{label}{required && <sup>*</sup>}</div>
      <Select
        placeholder={placeholder}
        options={options}
        onBlur={() => onBlur(value)}
        value={value || ''}
        optionClassName={s.options}
        {...other}
      />
      {touched && error && <span className={s.message}>{error}</span>}
    </div>
  );
}

export default InputForm;



// WEBPACK FOOTER //
// ./src/components/common/Select/Select.js